const data = [
    {
      id: "tt10872600",
      title: "Spider-Man",
      year: "2021",
      type: "Movie",
      poster:
        "https://m.media-amazon.com/images/M/MV5BZWMyYzFjYTYtNTRjYi00OGExLWE2YzgtOGRmYjAxZTU3NzBiXkEyXkFqcGdeQXVyMzQ0MzA0NTM@._V1_SX300.jpg",
    },
    {
      id: "tt2953050",
      title: "Encanto",
      year: "2021",
      type: "Movie",
      poster:
        "https://m.media-amazon.com/images/M/MV5BNjE5NzA4ZDctOTJkZi00NzM0LTkwOTYtMDI4MmNkMzIxODhkXkEyXkFqcGdeQXVyNjY1MTg4Mzc@._V1_SX300.jpg",
    },
    {
      id: "tt7991608",
      title: "Red Notice",
      year: "2021",
      type: "Movie",
      poster:
        "https://m.media-amazon.com/images/M/MV5BZmRjODgyMzEtMzIxYS00OWY2LTk4YjUtMGMzZjMzMTZiN2Q0XkEyXkFqcGdeQXVyMTkxNjUyNQ@@._V1_SX300.jpg",
    },
    {
      id: "tt12689248",
      title: "The Commando",
      year: "2022",
      type: "Movie",
      poster:
        "https://m.media-amazon.com/images/M/MV5BYTQ5ZjM3YmQtNTQ4ZC00NzBmLTk5YTUtN2I1NWRhYzcyNzgzXkEyXkFqcGdeQXVyNDA1NDA2NTk@._V1_SX300.jpg",
    },
    {
      id: "tt14060094",
      title: "Blacklight",
      year: "2022",
      type: "Movie",
      poster:
        "https://m.media-amazon.com/images/M/MV5BY2ViYmNhNzEtZDJhNS00YzM4LTkzZWItZDJiNzc5ZDExOWZmXkEyXkFqcGdeQXVyMDA4NzMyOA@@._V1_SX300.jpg",
    },
    {
      id: "tt8097030",
      title: "Turning Red",
      year: "2022",
      type: "Movie",
      poster:
        "https://m.media-amazon.com/images/I/71GIRcPKE4L._AC_SL1100_.jpg",
    },
    {
      id: "tt14128670",
      title: "Kimi",
      year: "2022",
      type: "Movie",
      poster:
        "https://m.media-amazon.com/images/M/MV5BYjFmOWUwYjgtM2UyYS00M2FmLTgwNmUtMWIwNTc2ZTgzNmRhXkEyXkFqcGdeQXVyMTEyMjM2NDc2._V1_SX300.jpg",
    },
    {
      id: "tt13634480",
      title: "The Ice Age",
      year: "2022",
      type: "Movie",
      poster:
        "https://m.media-amazon.com/images/I/5109y5b3yOL._AC_.jpg",
    },
    {
      id: "tt9848626",
      title: "Transylvania 4",
      year: "2022",
      type: "Movie",
      poster:
        "https://m.media-amazon.com/images/M/MV5BZWM4MzUyYTAtMGFiYy00MmRkLWIyNDktMWFlMDlmZjJmNWZmXkEyXkFqcGdeQXVyMTM1MTE1NDMx._V1_SX300.jpg",
    },
    {
      id: "tt9032400",
      title: "Eternals",
      year: "2021",
      type: "Movie",
      poster:
        "https://m.media-amazon.com/images/M/MV5BMTExZmVjY2ItYTAzYi00MDdlLWFlOWItNTJhMDRjMzQ5ZGY0XkEyXkFqcGdeQXVyODIyOTEyMzY@._V1_SX300.jpg",
    },
    {
      id: "tt7740496",
      title: "Nightmare Alley",
      year: "2021",
      type: "Movie",
      poster:
        "https://m.media-amazon.com/images/M/MV5BOTI4NDhhNGEtZjQxZC00ZTRmLThmZTctOGJmY2ZlOTc0ZGY0XkEyXkFqcGdeQXVyMTkxNjUyNQ@@._V1_SX300.jpg",
    },
    {
      id: "tt11755740",
      title: "Texas Chainsaw",
      year: "2022",
      type: "Movie",
      poster:
        "https://m.media-amazon.com/images/M/MV5BMDU4Yzk1NmUtNDU4OC00YzVmLTgwOTUtYTY2NjNmMjY5YjVmXkEyXkFqcGdeQXVyMTQxNzMzNDI@._V1_SX300.jpg",
    },
  ];
  
  export default data;